import { render, staticRenderFns } from "./Adver.vue?vue&type=template&id=6b99a17c&scoped=true&"
import script from "./Adver.vue?vue&type=script&lang=js&"
export * from "./Adver.vue?vue&type=script&lang=js&"
import style0 from "./Adver.vue?vue&type=style&index=0&id=6b99a17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99a17c",
  null
  
)

export default component.exports